function parseDate(value) {
  if (value == null || value === "") return null;
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) return null;
  return date;
}

/** Date only for table listings — e.g. 22 Jun 2026 */
export function formatListingDate(value, fallback = "—") {
  const date = parseDate(value);
  if (!date) return fallback;
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/** Date + time for table listings — e.g. 22 Jun 2026, 02:30 pm */
export function formatListingDateTime(value, fallback = "—") {
  const date = parseDate(value);
  if (!date) return fallback;
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

/** Time only — e.g. 02:30 pm */
export function formatListingTime(value, fallback = "—") {
  const date = parseDate(value);
  if (!date) return fallback;
  return date.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}
